import { render } from "./FormIzin.vue?vue&type=template&id=b74261ce"
import script from "./FormIzin.vue?vue&type=script&lang=js"
export * from "./FormIzin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__